import React, { Component } from 'react';
import Slide from 'react-reveal/Slide';
import axios from 'axios';
import Pagination from 'rc-pagination';
import 'rc-pagination/assets/index.css';
import { debounce } from 'lodash';
import { env } from '../../../../shared/environment';
import AddUser from './addUser';
import AreYouSure from '../../../../shared/components/areYouSure';
import './Users.scss';

class Contacts extends Component {
  baseUrl = env.baseUrl;
  params = {
    full_name: '',
    email: '',
    rows_limit: 10,
    rows_offset: 0,
  };

  constructor() {
    super();

    this.state = {
      full_name: '',
      email: '',
      users: [],
      errMessage: '',
      pageSize: 10,
      total: 0,
      current: 1,
    };

    this.onChangeFullname = this.onChangeFullname.bind(this);
    this.onChangeEmail = this.onChangeEmail.bind(this);
    this.onShowSizeChange = this.onShowSizeChange.bind(this);
    this.onPaginate = this.onPaginate.bind(this);
    this.getUsers = this.getUsers.bind(this);
    this.search = this.search.bind(this);
  }

  componentDidMount() {
    axios
      .post(`${this.baseUrl}users`, this.params)
      .then((response) => {
        this.setState({
          users: response.data.payload,
          total: response.data.info,
        });
      })
      .catch(function (error) {
        console.log('err: ', error);
      });
  }

  getUsers(params) {
    axios
      .post(`${this.baseUrl}users`, params)
      .then((response) => {
        this.setState({
          users: response.data.payload,
        });
      })
      .catch(function (error) {
        console.log('err: ', error);
      });
  }

  search = debounce(() => {
    axios
      .post(`${this.baseUrl}users`, this.params)
      .then((response) => {
        this.setState({
          users: response.data.payload,
          total: response.data.info,
        });
      })
      .catch(function (error) {
        console.log('err: ', error);
      });
  }, 400);

  deleteUser(id) {
    axios
      .delete(`${this.baseUrl}users/delete/${id}`)
      .then((response) => {
        if (response.data.code == 200) {
          window.location.reload();
        } else {
          this.setState({ errMessage: response.data.message });
        }
      })
      .catch((error) => {
        console.log('err: ', error);
      });
  }

  onShowSizeChange(event) {
    this.setState({ pageSize: Number(event.target.value) });
    this.params.rows_limit = Number(event.target.value);

    this.getUsers(this.params);
  }

  onChangeFullname(event) {
    this.setState({ full_name: event.target.value });
    this.params.full_name = event.target.value;
    this.search();
  }

  onChangeEmail(event) {
    this.setState({ email: event.target.value });
    this.params.email = event.target.value;
    this.search();
  }

  onPaginate(page) {
    this.setState({ current: page });
    this.params.rows_offset = (page - 1) * 10;

    this.getUsers(this.params);
  }

  render() {
    const users =
      this.state.users && this.state.users.length > 0
        ? this.state.users.map((user, index) => {
            return (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>{user.full_name}</td>
                <td>{user.email}</td>
                <td>
                  <span
                    className={
                      user.role == 'admin'
                        ? 'badge badge-danger'
                        : 'badge badge-secondary'
                    }
                  >
                    {user.role}
                  </span>
                </td>
                <td>{user.create_date}</td>
                <td>
                  <AddUser
                    action="edit" // EDIT user button
                    buttonLabel="edit"
                    id={user.id}
                    full_name={user.full_name}
                    email={user.email}
                    role={user.role}
                    onSuccess={this.search}
                    icon="fa fa-edit"
                    btnClass="btn-sm btn-info"
                    className="metronic-font"
                    modalHeader="Изменить Пользователя"
                    successMessage="Пользовател успешно отредактирован!"
                  />
                  <AreYouSure
                    buttonLabel="delete" // DELETE user button
                    btnClass="btn btn-sm btn-danger mx-1"
                    btnIcon="fa fa-trash"
                    click={() => this.deleteUser(user.id)}
                    errMessage={this.state.errMessage}
                  />
                </td>
              </tr>
            );
          })
        : '';

    return (
      <div className="row">
        <div className="col-12">
          <Slide top>
            <div className="row">
              <div className="col-12 mb-2">
                <div className="c-top">
                  <div className="c-body" style={{ height: '70px' }}>
                    <h4 className="float-left">ПОЛЬЗОВАТЕЛИ</h4>
                    <AddUser
                      action="add"
                      buttonLabel="Добавить"
                      float="float-right"
                      onSuccess={this.search}
                      btnClass="btn-sm"
                      className="metronic-font"
                      icon="fa fa-plus-circle"
                      modalHeader="Добавить пользователя"
                      successMessage="Пользователь успешно добавлен!"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="c-bottom">
              <div className="c-body">
                <div className="row">
                  <div className="col-6 mb-2">
                    <select
                      className="form-control form-control-sm float-left"
                      onChange={this.onShowSizeChange}
                      value={this.state.pageSize}
                      style={{ width: '80px' }}
                    >
                      <option value="10">10</option>
                      <option value="20">20</option>
                      <option value="50">50</option>
                    </select>
                  </div>
                  <div className="col-6">
                    <div>
                      <div
                        className="input-group float-right"
                        style={{ width: '500px' }}
                      >
                        <input
                          className="form-control form-control-sm"
                          value={this.state.email}
                          onChange={this.onChangeEmail}
                          placeholder="Email"
                        />
                        <input
                          className="form-control form-control-sm"
                          value={this.state.full_name}
                          onChange={this.onChangeFullname}
                          placeholder="ФИО"
                        />
                        <div className="input-group-append">
                          <button
                            className="btn btn-sm btn-info"
                            onClick={this.search}
                          >
                            Поиск
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12">
                    <table className="table">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>ФИО</th>
                          <th>Email</th>
                          <th>Роль</th>
                          <th>Дата регистрации</th>
                          <th>Действия</th>
                        </tr>
                      </thead>
                      <tbody>{users}</tbody>
                    </table>
                    <Pagination
                      className="float-right"
                      pageSize={this.state.pageSize}
                      onShowSizeChange={this.onShowSizeChange}
                      onChange={this.onPaginate}
                      current={this.state.current}
                      showTotal={(total, range) =>
                        `${range[0]} - ${range[1]} of ${total}`
                      }
                      total={this.state.total}
                    />
                  </div>
                </div>
              </div>
            </div>
          </Slide>
        </div>
      </div>
    );
  }
}

export default Contacts;
